import { render, staticRenderFns } from "./package-prod-components.vue?vue&type=template&id=3ff4dc82"
import script from "./package-prod-components.vue?vue&type=script&lang=js"
export * from "./package-prod-components.vue?vue&type=script&lang=js"
import style0 from "./package-prod-components.vue?vue&type=style&index=0&id=3ff4dc82&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports